<template lang="pug">
    v-btn.button(
        :color="color"
        @click.stop="action"
        flat
        icon
    )
        v-icon.icon {{ icon }}
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            color: VueTypes.string.def('primary'),
            icon: VueTypes.string.def('edit'),
            action: VueTypes.func.def(() => {})
        }
    };
</script>

<style lang="stylus" scoped>
    .button
        width: 30px
        height: 30px
        margin: 2px

    .icon
        font-size: 22px;
        margin: 0
</style>
